var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.source === 'font-awesome')?_c('FontAwesomeIcon',_vm._b({attrs:{"icon":_vm.fontAwesomeIcon}},'FontAwesomeIcon',_vm.$attrs,false)):(_vm.source === 'custom')?_c('span',{class:_vm.customIconClass}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }